import { defineComponent as _defineComponent } from 'vue'
import { PHARMACEUTICAL_DOMAIN_CONFIG } from '@/constants/pharmaceuticalDomainConfig'
import { computed, ref } from 'vue'
import { useAuthStore } from '@/store/pinia/auth'
import RadioOption from './RadioOption.vue'
import { useApi } from '@/plugins/api'
import { useRouter } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectProject',
  setup(__props) {

const authStore = useAuthStore()
const api = useApi()
const router = useRouter()

const projects = computed<
  {
    id: number
    title: string
  }[]
>(() => {
  /*
   const pharmaceuticalIdArray = (authStore.user?.pharmaceuticals || []).map((item) => item.id)

  return Object.values(PHARMACEUTICAL_DOMAIN_CONFIG.DEFAULT)
    .filter((pharmaceutical) => pharmaceuticalIdArray.includes(pharmaceutical.PHARMACEUTICAL_ID))
    .map((item) => ({
      id: item.PHARMACEUTICAL_ID,
      title: item.PROJECT_TITLE,
    }))
  */

  return []
})

async function changeProject(pharmaceuticalId: number) {
  authStore.setCurrentHomePage('home')
  const homeRoute = router.resolve({ name: 'home' })

  window.location.assign(homeRoute.href)
}

return { __sfc: true,authStore, api, router, projects, changeProject, RadioOption }
}

})